import { render, staticRenderFns } from "./CmgDietaryFiltersModal.vue?vue&type=template&id=41749ebd&scoped=true&lang=pug&"
import script from "./cmg-dietary-filters-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-dietary-filters-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgDietaryFiltersModal.vue?vue&type=style&index=0&id=41749ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41749ebd",
  null
  
)

export default component.exports